var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import ModalBase from "../../components/modalbase.vue";
import LayeredView from "../../components/dialog/layeredview.vue";
import { isNumber, isTwoDimInput, } from "../utilities/wsi4_typeguards";
let LayeredDialog = class LayeredDialog extends Vue {
    constructor() {
        super(...arguments);
        this.valid = false;
    }
    ignoreLayered() { }
    changeResult() {
        if (!isTwoDimInput(this.twoDimInput)) {
            throw Error("Only send result if valid.");
        }
        return this.twoDimInput;
    }
    cuttingSelection() {
        if (this.twoDimInput === undefined) {
            return false;
        }
        return this.twoDimInput.cuttingLds.length !== 0;
    }
    thicknessValid() {
        if (this.twoDimInput === undefined) {
            return false;
        }
        return isNumber(this.twoDimInput.thickness) && this.twoDimInput.thickness > 0;
    }
    changeTwoDimInput(result) {
        this.twoDimInput = result;
        this.valid = this.cuttingSelection() && this.thicknessValid();
    }
    mounted() {
        this.twoDimInput = {
            layered: this.invalidLayered.layered,
            name: this.invalidLayered.name,
            thickness: 0,
            cuttingLds: [],
            engravingLds: [],
            importId: this.invalidLayered.importId,
        };
    }
};
__decorate([
    Prop({ required: true })
], LayeredDialog.prototype, "invalidLayered", void 0);
__decorate([
    Prop({ required: true })
], LayeredDialog.prototype, "defaultResult", void 0);
__decorate([
    Inject()
], LayeredDialog.prototype, "i18n", void 0);
__decorate([
    Emit()
], LayeredDialog.prototype, "ignoreLayered", null);
__decorate([
    Emit()
], LayeredDialog.prototype, "changeResult", null);
LayeredDialog = __decorate([
    Component({
        components: {
            ModalBase,
            LayeredView,
        },
        name: "LayeredDialog",
    })
], LayeredDialog);
export default LayeredDialog;
